import { createRouter, createWebHashHistory } from 'vue-router';

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('../views/login/login.vue')
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('../views/map/map.vue')
    }
  ]
});

export default router;
